<template>
  <div class="img__container--div">
    <img :src="page.bigImg == '' ? require('@/assets/templateImg.png'): page.bigImg"/>
  </div>
</template>
<script>
export default {
  name:'SampleTemplate', // 示例模板
  props: {
    page: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {}
  }
}
</script>
<style lang="less" scoped>
.img__container--div{
  width: 100%;
  img{
    width: 100%;
  }
}
.sample__box--div{
  background: #EEEEEE;
  margin: 16px;
  display: flex;
  justify-content: space-between;
  .conent__left--div{
    // width: 74%;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    margin:16px;
    .left__top--div{
      background: #fff;
      margin-bottom: 16px;
      height: 200px;
      // height: 100%;
    }
    .right__bottom--div{
      background: #fff;
      height: 300px;
      // height: 100%;
    }
  }
  .conent__right--div{
    // width: 40%;
    width: 50%;
    height: inherit;
    box-sizing: border-box;
    margin:16px;
    background: #fff;
  }
}
</style>